var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_vm._v(" "),_c('div',{staticClass:"maindiv znotice-wrap bg-gray"},[_c('div',{staticClass:"notices htmldiv",staticStyle:{"padding-top":"20px"}},[_c('div',{staticClass:"bgw"},[_c('Detail',{attrs:{"info":_vm.info}})],1)]),_vm._v(" "),_c('div',{staticClass:"ht30"})]),_vm._v(" "),_c('Bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b21901b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zedu/notice/detail.vue
// module id = null
// module chunks = 